import React, { forwardRef, useRef } from 'react';
import { Icon } from '@iconify/react';
import { cn } from './utils';

const SearchInput = forwardRef(function SearchInput(
  { className, style, value, onChange, onClear, placeholder = 'Search...', disabled, readOnly, ...props },
  forwardedRef
) {
  const localRef = useRef(null);
  const setRef = (node) => {
    localRef.current = node;
    if (typeof forwardedRef === 'function') forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };

  const clearSearch = () => {
    if (onClear) onClear();
    else onChange?.({ target: { value: '', name: props.name, id: props.id } });
    localRef.current?.focus();
  };

  return (
    <div className="tw-relative tw-w-full tw-min-w-0 app-search" style={style}>
      <Icon icon="fluent:search-24-regular" aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 tw-z-[1] tw-h-5 tw-w-5 -tw-translate-y-1/2 tw-text-slate-500" />
      <input
        {...props}
        ref={setRef}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        aria-label={props['aria-label'] || placeholder}
        className={cn('app-search-input tw-w-full', className)}
      />
      {!disabled && !readOnly && Boolean(value?.length) && (
        <button
          type="button"
          aria-label="Clear search"
          title="Clear search"
          onMouseDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
            clearSearch();
          }}
          className="tw-absolute tw-right-1.5 tw-top-1/2 tw-z-[1] tw-flex tw-h-8 tw-w-8 -tw-translate-y-1/2 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-slate-500 hover:tw-bg-slate-100 hover:tw-text-slate-900 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-brand-500"
        >
          <Icon icon="fluent:dismiss-16-regular" aria-hidden="true" className="tw-h-4 tw-w-4" />
        </button>
      )}
    </div>
  );
});

export default SearchInput;
